import ApexCharts from 'apexcharts'

window.addEventListener('load', (event) => {
    const ctx = document.getElementById('scoreChart');

    if (ctx) {

        var options = {
            chart: {
                type: "radar",
                height: '400'
            },
            series: [{
                name: 'Scores',
                data: window.chartJson
            }],
            labels: [
                'Facilities',
                'Events',
                'Organizational Structure',
                'Destination Strength',
            ],
            yaxis: {
                show: false
            },
            dataLabels: {
                enabled: true,
                background: {
                    enabled: true,
                    borderRadius:2,
                }
            }
        }

        var chart = new ApexCharts(ctx, options);

        chart.render();
    }
});